import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

type Art = 'info' | 'erfolg' | 'warnung' | 'fehler';

const STIL: Record<Art, string> = {
  info: 'bg-slate-100 text-slate-800 ring-slate-200 dunkel:bg-slate-800 dunkel:text-slate-100 dunkel:ring-slate-700',
  erfolg:
    'bg-emerald-50 text-emerald-900 ring-emerald-200 dunkel:bg-emerald-950 dunkel:text-emerald-100 dunkel:ring-emerald-800',
  warnung:
    'bg-amber-50 text-amber-900 ring-amber-200 dunkel:bg-amber-950 dunkel:text-amber-100 dunkel:ring-amber-800',
  fehler:
    'bg-red-50 text-red-900 ring-red-200 dunkel:bg-red-950 dunkel:text-red-100 dunkel:ring-red-800',
};

const SYMBOL: Record<Art, string> = {
  info: 'ℹ',
  erfolg: '✓',
  warnung: '!',
  fehler: '✕',
};

export interface HinweisProps {
  art?: Art;
  titel?: string;
  children?: ReactNode;
  className?: string;
  /** Fehler und Warnungen werden Screenreadern sofort vorgelesen. */
  sofortMelden?: boolean;
}

export const Hinweis = ({
  art = 'info',
  titel,
  children,
  className,
  sofortMelden,
}: HinweisProps) => (
  <div
    role={art === 'fehler' ? 'alert' : 'status'}
    aria-live={(sofortMelden ?? art === 'fehler') ? 'assertive' : 'polite'}
    className={cn('rounded-lg px-4 py-3 text-sm ring-1 ring-inset', STIL[art], className)}
  >
    <div className="flex gap-3">
      <span aria-hidden="true" className="mt-px font-bold">
        {SYMBOL[art]}
      </span>
      <div className="min-w-0 flex-1">
        {titel && <p className="font-semibold">{titel}</p>}
        {children && <div className={cn(titel && 'mt-1', 'leading-relaxed')}>{children}</div>}
      </div>
    </div>
  </div>
);
